import { faNumber, toFaDigits } from './faNumbers'

const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

/**
 * «۱۲ دقیقه پیش». Built by hand rather than with Intl.RelativeTimeFormat so the
 * digits go through faNumber — Intl's fa locale output varies by engine, and the
 * handhelds must render identically to the artboard.
 */
export function relativeTimeFa(instant: Date | string | number, now: Date = new Date()): string {
  const then = instant instanceof Date ? instant : new Date(instant)
  const elapsed = now.getTime() - then.getTime()

  if (Number.isNaN(elapsed)) {
    return '—'
  }

  if (elapsed < 10_000) {
    return 'همین حالا'
  }

  if (elapsed < MINUTE) {
    return `${faNumber(Math.floor(elapsed / 1000))} ثانیه پیش`
  }

  if (elapsed < HOUR) {
    return `${faNumber(Math.floor(elapsed / MINUTE))} دقیقه پیش`
  }

  if (elapsed < DAY) {
    return `${faNumber(Math.floor(elapsed / HOUR))} ساعت پیش`
  }

  return `${faNumber(Math.floor(elapsed / DAY))} روز پیش`
}

/** «۰۸:۱۴» — wall clock for the «آخرین ارسال موفق» row. Zero-padded, Persian digits. */
export function clockFa(instant: Date | string | number): string {
  const date = instant instanceof Date ? instant : new Date(instant)

  if (Number.isNaN(date.getTime())) {
    return '—'
  }

  const hh = String(date.getHours()).padStart(2, '0')
  const mm = String(date.getMinutes()).padStart(2, '0')

  return toFaDigits(`${hh}:${mm}`)
}
